import { type FC } from "react";
import { GuidanceBox } from "@root/shared/components/GuidanceBox";
import * as styles from "./styles.css";

export const Infomation: FC = () => (
  <div className={styles.wrapper}>
    <p className={styles.text}>
      みなさまが安心して転職活動を行えるよう、適切なサービスの運営に努めております。
    </p>
    <p className={styles.text}>
      万が一、応募先企業で違反行為の疑いがある場合、当フォームよりご報告をお願いいたします。
    </p>
    <p className={styles.text}>
      ご自身に持ちかけられた場合だけではなく、周囲で見かけた場合にもこちらよりご報告ください。
    </p>
    <p className={styles.text}>
      ※違反行為の事実確認が出来た場合には、ご報告へのご協力およびご迷惑をおかけしたことへのお詫びとして、
      <br />
      <span className={styles.importantText}>謝礼金（20,000円）</span>をお渡しいたします。
    </p>
    <GuidanceBox themeColor="gray" className={styles.guidanceBox}>
      <p className={styles.guidanceBoxTitle}>情報の取り扱いについて</p>
      <ul className={styles.dotList}>
        <li className={styles.dotListItem}>
          ご報告いただいた内容を直ちに企業へ伝えることはありませんのでご安心ください。
        </li>
        <li className={styles.dotListItem}>
          詳細なご状況の確認のために、弊社よりご登録の連絡先（電話・メール・SMS等）にご連絡をさせていただく場合がございます。その際にはご協力をいただけますと幸いです。
        </li>
        <li className={styles.dotListItem}>
          ご報告いただいた情報をもとに、不正や違反等の有無を調査し、弊社にて問題があると判断した場合には然るべき対応をいたします。
        </li>
        <li className={styles.dotListItem}>
          ご報告いただきました内容に関する調査結果・対応内容につきましては開示いたしかねる場合がございます。予めご了承ください。
        </li>
      </ul>
    </GuidanceBox>
  </div>
);
